// The slide manager handles transitioning between slides.
export function SlideManager() {
	this.slides = [];
	this.currentSlideIndex = -1;
	this.timeoutId = null;
}
// Add a slide to the slide manager. This should be done before `start()` is
// called.
SlideManager.prototype.registerSlide = function(slide) {
	slide.enabled = true;
	this.slides.push(slide);
};
// Start!
SlideManager.prototype.start = function() {
	var self = this;
	// First, create all of the elements.
	this.slides.forEach(function(slide) {
		var slideElement = slide.element;
		if (!slideElement) {
			// Get the <template> element.
			var template = document.querySelector(slide.template);
			// Clone it, and get the slide within. All elements _should_ have
			// a slide element.
			slideElement = template.content.cloneNode(true).querySelector('.slide');
			// Store it in the slide structure.
			slide.element = slideElement;
			// Tell listeners that it was created
			self._raiseSlideCreated(slide);
			// And, if the slide wants to know that its element was created,
			// notify it.
			if (slide.action && slide.action.elementCreated) {
				slide.action.elementCreated(slideElement);
			}
		}
	});

	// Then, start transitioning between slides.
	setTimeout(this._updateSlide.bind(this), 0);
};
SlideManager.prototype._raiseSlideCreated = function _raiseSlideCreated(slide) {
	if (this.onSlideCreated) {
		this.onSlideCreated(slide);
	}
};
SlideManager.prototype._raiseSlideChanging = function _raiseSlideChanging(slide) {
	if (this.onSlideChanging) {
		this.onSlideChanging(slide);
	}
};
SlideManager.prototype.nextSlide = function nextSlide() {
	console.log("NEXT SLIDE");
	if (this.timeoutId) {
		clearTimeout(this.timeoutId);
	}

	this._updateSlide();
};
SlideManager.prototype._updateSlide = function _updateSlide() {
	console.log("_UPDATE SLIDE");
	var slides = this._moveForward();
	var previousSlide = slides.previous;
	var currentSlide = slides.current;
	var nextSlide = slides.next;

	if (previousSlide && previousSlide.action) {
		previousSlide.action.onTriggerNext = null;
	}
	if (currentSlide && currentSlide.action) {
		currentSlide.action.onTriggerNext = this.nextSlide.bind(this);
	}

	// Notify the previous slide that it is being hidden, if it wants to know.
	if (previousSlide && previousSlide.action && previousSlide.action.hide) {
		previousSlide.action.hide();
	}
	// Notify the current slide that it is being shown, if it wants to know.
	if (currentSlide && currentSlide.action && currentSlide.action.show) {
		currentSlide.action.show();
	}
	// Notify the next slide that it is next up, if it wants to know. This
	// lets it load data via AJAX, or do whatever else it needs to do.
	if (nextSlide && nextSlide.action && nextSlide.action.prepare) {
		nextSlide.action.prepare();
	}

	// Set a timeout so that we transition to the next slide when the time
	// comes.
	this.timeoutId = null;
	if (currentSlide.duration > 0) {
		this.timeoutId = setTimeout(this._updateSlide.bind(this), currentSlide.duration);
	}

	// And notify a listener that we're changing slides. This allows script.js
	// to do all of the html-ish stuff that needs to be done.
	this._raiseSlideChanging(currentSlide);
};
// Move forward and return the previous, current, and next slides. This
// function affects this.currentSlideIndex.
SlideManager.prototype._moveForward = function _moveForward() {
	console.log("_MOVE FORWARD");
	// Figure out if we have a previous slide.
	var previousSlide = null;
	// If currentSlideIndex = -1, this is our first time through. After that,
	// currentSlideIndex should never be -1.
	if (this.currentSlideIndex > -1) {
		previousSlide = this.slides[this.currentSlideIndex];
	}

	var currentSlide = null;
	var currentSlideIndex = this.currentSlideIndex;
	while (true) {
		currentSlideIndex = (currentSlideIndex + 1) % this.slides.length;
		currentSlide = this.slides[currentSlideIndex];
		if (currentSlide.enabled) {
			break;
		}
	}

	var nextSlide = null;
	var nextSlideIndex = currentSlideIndex;
	while (true) {
		nextSlideIndex = (nextSlideIndex + 1) % this.slides.length;
		nextSlide = this.slides[nextSlideIndex];
		if (nextSlide.enabled) {
			break;
		}
	}

	// Get the current and next slide.
	this.currentSlideIndex = currentSlideIndex;

	return {
		previous: previousSlide,
		current: currentSlide,
		next: nextSlide
	};
};
SlideManager.prototype.setSlideState = function setSlideState(id, enabled) {
	var slide = null;

	this.slides.forEach(function(element) {
		if (element.id === id) {
			slide = element;
		}
	});
	if (slide !== null) {
		slide.enabled = enabled;
	}
};
SlideManager.prototype.enableSlide = function enableSlide(id) {
	return this.setSlideState(id, true);
};
SlideManager.prototype.disableSlide = function disableSlide(id) {
	return this.setSlideState(id, false);
};
